import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { requestRenewCreditLimits } from '../../../../store/ducks/credit-limits/actions';
import { ICreditLimitsState } from '../../../../store/ducks/credit-limits/types';
import { ICustomer } from '../../../../store/ducks/customers/types';
import { formatCurrency } from '../../../../utils/formatNumbers';
import RenewCreditUploadDocsModalContent from './RenewCreditUploadDocsModalContent';
import { Modal } from '@gerdau/hefesto/Modal';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { Button } from '@gerdau/hefesto/Button';
import { ActionsContainer } from './styles';

interface ICreditRenewProps {
  creditLimitsState: ICreditLimitsState;
  selectedCustomer: ICustomer;
}

const CreditRenew: React.FC<ICreditRenewProps> = ({
  creditLimitsState,
  selectedCustomer
}) => {
  const dispatch = useDispatch();

  const [showRenewCredidtUploadDocsModal, setShowRenewCredidtUploadDocsModal] =
    useState(false);
  const [showConfirmRenewCreditModal, setShowConfirmRenewCreditModal] =
    useState(false);
  const [showRenewCreditMessage, setShowRenewCreditMessage] = useState(false);

  const [renewValue, setRenewValue] = useState(
    creditLimitsState.creditLimits
      ? Number(creditLimitsState.creditLimits.creditLimit)
      : 0
  );
  const [creditRenewDocs, setCreditRenewDocs] = useState<File[]>([]);
  const [isRenewValueConfirm, setIsRenewValueConfirm] = useState(false);

  const onRenewCreditClick = () => {
    if (!creditLimitsState.creditLimits) {
      return false;
    }

    if (Number(creditLimitsState.creditLimits.creditLimit) <= 250000) {
      setShowConfirmRenewCreditModal(true);
    } else {
      setShowRenewCredidtUploadDocsModal(true);
    }

    dispatch(
      sendTagging({
        screenName: 'LG:Financas:MinhasFinancas',
        event: 'click',
        itemName: 'button:renovar_credito',
        itemDescription: 'financas_minhas_financas_renovarCredito'
      })
    );
  };

  const onRenewCreditConfirm = () => {
    setShowConfirmRenewCreditModal(false);
    dispatch(
      requestRenewCreditLimits(selectedCustomer, renewValue, creditRenewDocs)
    );
    setShowRenewCreditMessage(true);
  };

  return (
    <>
      {!selectedCustomer.creditRenew && (
        <ActionsContainer>
          <Button
            variant="secondary"
            name="creditRenewButton"
            disabled={creditLimitsState.renewCreditLoading}
            onClick={onRenewCreditClick}
            loading={creditLimitsState.renewCreditLoading}
          >
            Renovar crédito
          </Button>
        </ActionsContainer>
      )}

      {showRenewCredidtUploadDocsModal && (
        <Modal
          title="Renovação do limite de crédito"
          modalSize="lg"
          onClose={() => {
            setShowRenewCredidtUploadDocsModal(false);
          }}
          buttons={{
            left: {
              children: 'Cancelar',
              name: 'cancelar',
              onClick: () => {
                dispatch(
                  sendTagging({
                    screenName:
                      'LG:Financas:MinhasFinancas:ModalRenovacaoLimiteCredito',
                    event: 'click',
                    itemName: 'button:cancelar',
                    itemDescription:
                      'financas_minhas_financas_modalRenovacaoLimiteCredito_cancelar'
                  })
                );
                if (
                  !creditLimitsState.renewCreditLoading &&
                  isRenewValueConfirm
                ) {
                  setRenewValue(
                    creditLimitsState.creditLimits
                      ? Number(creditLimitsState.creditLimits.creditLimit)
                      : 0
                  );
                  setCreditRenewDocs([]);

                  setShowRenewCredidtUploadDocsModal(false);
                }

                setIsRenewValueConfirm(true);
              },
              type: 'button',
              disabled: creditLimitsState.renewCreditLoading
            },
            right: {
              children: 'Solicitar renovação',
              name: 'solicitar-renovacao',
              onClick: () => {
                dispatch(
                  sendTagging({
                    screenName:
                      'LG:Financas:MinhasFinancas:ModalRenovacaoLimiteCredito',
                    event: 'click',
                    itemName: 'button:solicitar_renovacao',
                    itemDescription:
                      'financas_minhas_financas_modalRenovacaoLimiteCredito_solicitarRenovacao'
                  })
                );

                setShowConfirmRenewCreditModal(true);
                setIsRenewValueConfirm(true);
              },
              type: 'button',
              disabled:
                creditLimitsState.renewCreditLoading ||
                (creditRenewDocs.length < 4 && renewValue > 250000) ||
                renewValue < 1 ||
                !renewValue
            }
          }}
        >
          <RenewCreditUploadDocsModalContent
            renewValue={renewValue}
            setNewCreditLimit={setRenewValue}
            setCreditRenewDocs={setCreditRenewDocs}
            loading={!!creditLimitsState.renewCreditLoading}
          />
        </Modal>
      )}

      {showConfirmRenewCreditModal && (
        <Modal
          title="Renovação de Crédito"
          modalSize="lg"
          buttons={{
            left: {
              children: 'Não',
              name: 'nao',
              onClick: () => {
                if (
                  !creditLimitsState.renewCreditLoading &&
                  isRenewValueConfirm
                ) {
                  setRenewValue(
                    creditLimitsState.creditLimits
                      ? Number(creditLimitsState.creditLimits.creditLimit)
                      : 0
                  );
                  setCreditRenewDocs([]);
                }

                setIsRenewValueConfirm(true);
                setShowConfirmRenewCreditModal(false);
              },
              type: 'button'
            },
            right: {
              children: 'Sim',
              name: 'sim',
              onClick: onRenewCreditConfirm,
              type: 'button'
            }
          }}
          onClose={() => setShowConfirmRenewCreditModal(false)}
          children={
            <>
              {' '}
              <p>
                Você solicitou a renovação do seu{' '}
                <strong>limite de crédito</strong> em{' '}
                <strong>R$ {formatCurrency(renewValue.toString())}</strong>.
              </p>
              <p>Deseja prosseguir?</p>
            </>
          }
        ></Modal>
      )}

      {showRenewCreditMessage && !creditLimitsState.renewCreditLoading && (
        <Modal
          title={
            creditLimitsState.renewCreditError
              ? 'Falha na solicitação'
              : creditLimitsState.renewCreditAlreadyRequested
              ? 'Atenção'
              : 'Sucesso!'
          }
          modalSize="lg"
          onClose={() => setShowRenewCreditMessage(false)}
          children={
            <>
              {creditLimitsState.renewCreditError ? (
                <p>
                  Não foi possível completar a solicitação de renovação de
                  limite de crédito.
                  <br />
                  Tente novamente mais tarde.
                </p>
              ) : creditLimitsState.renewCreditAlreadyRequested ? (
                <p>
                  Solicitação de renovação de limite de crédito já registrada.
                  <br />
                  Solicitação{' '}
                  <strong>nº {selectedCustomer.creditRenewCode}</strong>.
                  <br />
                  Em caso de dúvidas, entre em contato com o seu vendedor.
                </p>
              ) : (
                <p>
                  Solicitação de renovação de limite de crédito{' '}
                  <strong>nº {selectedCustomer.creditRenewCode}</strong>{' '}
                  enviada.
                </p>
              )}
            </>
          }
          buttons={{
            right: {
              children: 'Não',
              name: 'nao',
              onClick: () => {
                setShowRenewCreditMessage(false);
                setShowRenewCredidtUploadDocsModal(false);
              },
              type: 'button'
            }
          }}
        ></Modal>
      )}
    </>
  );
};

export default CreditRenew;
